import buttonLikeRoles from "./buttonLikeRoles";
import isDisabled from "./isDisabled";
import propsToAccessibilityComponent from "./propsToAccessibilityComponent";
import propsToAriaRole from "./propsToAriaRole";
var AccessibilityUtil = {
  buttonLikeRoles: buttonLikeRoles,
  isDisabled: isDisabled,
  propsToAccessibilityComponent: propsToAccessibilityComponent,
  propsToAriaRole: propsToAriaRole
};
export default AccessibilityUtil;